import { isEqual } from 'lodash';
import type { SettingsFormState } from '../../../services/settings/settingsReducer';

export const isEqualFormStates = (
  initial: SettingsFormState | undefined,
  edited: SettingsFormState | undefined,
): boolean => {
  return !!initial && !!edited && isEqual(initial, edited);
};
